import { Reducer as LoginReducer } from 'modules/login';

import {
    INVITEE_PAGE,
    PLATFORM_REGISTRATION,
    REFERRAL_DASHBOARD,
    ERROR
} from '../../states/states.constants';

import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';

import { loginSessionMock } from 'modules/__mocks__/login-session.mock';

export const loginSession = (state = LoginReducer.initialState, action: SwitchPreviewStateAction): LoginReducer.IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case INVITEE_PAGE:
        case PLATFORM_REGISTRATION:
        case REFERRAL_DASHBOARD:
        case ERROR:
            return {
                fetching: false,
                loginSession: loginSessionMock,
                hasTPCEnabled: true,
                hasOverlayLoaded: false
            };
        default:
            return state;
        }
    }
    default:
        return state;
    }
};

export default loginSession;
